import activeLinkMenu from './active-link-menu'
import chatListMenu from './chat-list-menu'
import chatWithUserMenu from './chat-with-user-menu'
import contactMenu from './contact-menu'
import copyMenu from './copy-menu'
import deleteExceptionUserMenu from './delete-exception-user-menu'
import groupExceptionUserMenu from './group-exception-user-menu'
import hallMemberMenu from './hall-member-menu'
import hallProfileMenu from './hall-profile-menu'
import phoneMenu from './phone-menu'
import profilePictureMenu from './profile-picture-menu'
import removeBlockedUsersMenu from './remove-blocked-users-menu'
import removedUserMenu from './removed-user-menu'
import revokedLinkMenu from './revoked-link-menu'
import wappProfileMenu from './wapp-profile-menu'
import contextMenu from './context-menu'
import removeMenu from './remove-menu'
import linkMenu from './link-menu'
import hashtagMenu from './hashtag-menu'
import roomProfileMenu from './room-profile-menu'

export default {
  ...activeLinkMenu,
  ...chatListMenu,
  ...chatWithUserMenu,
  ...contactMenu,
  ...copyMenu,
  ...deleteExceptionUserMenu,
  ...groupExceptionUserMenu,
  ...hallMemberMenu,
  ...hallProfileMenu,
  ...phoneMenu,
  ...profilePictureMenu,
  ...removeBlockedUsersMenu,
  ...removedUserMenu,
  ...revokedLinkMenu,
  ...wappProfileMenu,
  ...contextMenu,
  ...removeMenu,
  ...linkMenu,
  ...hashtagMenu,
  ...roomProfileMenu,
}
